import { NavBar } from '@design-system/NavBar';
import { ToggleGroup, ToggleGroupItem } from '@design-system/ToggleGroup';
import { Skeleton } from '@design-system/Skeleton';

export const HealthL4ImproveMyScoreDetailSkeleton = () => {
  return (
    <section className='w-full page-container' data-testid="healthL4ImproveScore-skeletonPage">
      <NavBar returnButtonTitle="Health" className="md:-ml-5 mt-8" data-testid="healthL4ImproveScore-skeletonNavbar" />
      
      <div className="flex flex-col gap-4 mt-12" data-testid="healthL4ImproveScore-skeletonHeader">
        <Skeleton className="h-12 w-96" data-testid="healthL4ImproveScore-skeletonTitle" />
      </div>

      <div className='mt-6' data-testid="healthL4ImproveScore-skeletonFilterSection">
        <ToggleGroup type="single" variant="text" data-testid="healthL4ImproveScore-skeletonToggleGroup">
          <ToggleGroupItem 
            className='px-4 py-2 bg-white h-8 w-20' 
            value="Foods"
            disabled
            data-testid="healthL4ImproveScore-skeletonFoodsToggle"
          >
          </ToggleGroupItem>
          <ToggleGroupItem 
            className='px-4 py-2 bg-white h-8 w-20' 
            value="Ingredients"
            disabled
            data-testid="healthL4ImproveScore-skeletonIngredientsToggle"
          >
          </ToggleGroupItem>
        </ToggleGroup>
      </div>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-2 mt-12' data-testid="healthL4ImproveScore-skeletonItemsGrid">
        {[...Array(10)].map((_, index) => (
          <div
            key={index}
            className='w-full h-20 px-6 py-1 pr-5 rounded-md bg-white flex justify-between items-center'
            data-testid={`healthL4ImproveScore-skeletonItem-${index}`}
          >
            <div className="flex items-center gap-7" data-testid={`healthL4ImproveScore-skeletonItemContent-${index}`}>
              <div className="h-16 flex items-center justify-center" data-testid={`healthL4ImproveScore-skeletonItemImageContainer-${index}`}>
                <Skeleton className="w-10 h-10 rounded-md" data-testid={`healthL4ImproveScore-skeletonItemImage-${index}`} />
              </div>

              <div className="flex flex-col gap-2" data-testid={`healthL4ImproveScore-skeletonItemDetails-${index}`}>
                <Skeleton className="h-5 w-32" data-testid={`healthL4ImproveScore-skeletonItemName-${index}`} />
                <Skeleton className="h-4 w-24" data-testid={`healthL4ImproveScore-skeletonItemTag-${index}`} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};